<template>
  <div class="confidence-donut" :class="{ 'dark': isDark }" :title="`Confidence: ${confidence}%`">
    <svg width="32" height="32" viewBox="0 0 32 32" class="donut-svg">
      <!-- Background circle -->
      <circle
        cx="16"
        cy="16"
        r="12"
        fill="none"
        :stroke="isDark ? '#374151' : '#e5e7eb'"
        stroke-width="4"
      />
      
      <!-- Progress circle -->
      <circle
        cx="16"
        cy="16"
        r="12"
        fill="none"
        :stroke="donutColor"
        stroke-width="4"
        stroke-linecap="round"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
        transform="rotate(-90 16 16)"
        class="donut-progress"
      />
      
      <!-- Center text -->
      <text
        x="16"
        y="16"
        text-anchor="middle"
        dominant-baseline="middle"
        :fill="isDark ? '#f3f4f6' : '#1f2937'"
        font-size="8"
        font-weight="600"
        class="donut-text"
      >
        {{ confidence }}%
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ConfidenceDonut',
  props: {
    confidence: {
      type: Number,
      default: 0,
      validator: value => value >= 0 && value <= 100
    },
    isDark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    circumference() {
      return 2 * Math.PI * 12; // radius = 12
    },
    dashOffset() {
      return this.circumference - (this.confidence / 100) * this.circumference;
    },
    donutColor() {
      if (this.confidence >= 80) return '#22c55e'; // green
      if (this.confidence >= 50) return '#f97316'; // orange
      return '#ef4444'; // red
    }
  }
}
</script>

<style scoped>
.confidence-donut {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.confidence-donut:hover {
  opacity: 0.8;
}

.donut-svg {
  display: block;
}

.donut-progress {
  transition: stroke-dashoffset 0.3s ease, stroke 0.3s ease;
}

.donut-text {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  user-select: none;
}

.donut-label {
  font-size: 10px;
  font-weight: 500;
  color: #6b7280;
  text-align: center;
  white-space: nowrap;
}

.dark .donut-label {
  color: #9ca3af;
}
</style>
